// Generated from src/img/svg/s20.svg

export const S20 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#ea516c" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S20"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue",sans-serif',
          fontSize: "10px",
          fontWeight: "700",
        }}
      >
        <path d="M4.74 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77H8.99q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M12.72 5.69h-1.36q-.04-1.24.63-2.03.68-.8 1.91-.8 1 0 1.68.58.72.62.72 1.61 0 .93-.62 1.59-.31.33-1.36 1.01-.92.61-1.29 1.13h3.31V10H11.2q.01-1.09.65-1.87.41-.48 1.56-1.26.82-.56.97-.69.5-.46.5-1.02 0-.49-.3-.78-.29-.3-.75-.3-.58 0-.87.53-.24.43-.24 1.08M16.76 6.47q0-1.91.76-2.83.65-.78 1.8-.78 1.16 0 1.82.78.76.91.76 2.83 0 3.67-2.58 3.67-2.56 0-2.56-3.67m1.42 0q0 1.02.14 1.55.26.95 1 .95.75 0 1.02-.95.14-.53.14-1.55 0-2.44-1.16-2.44-1.14 0-1.14 2.44" />
      </g>
    </svg>
  );
};
